import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import SelectStatus from "components/select/status";
import { gradeSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useGradeForm } from "./useGradeForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";

const GradeForm = ({ gradeId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useGradeForm({
    gradeId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={gradeId || "+"}
      schema={gradeSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="grades"
                  type="form"
                >
                  <FormLabel required>Name</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Status */}
          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="grades"
                  type="form"
                >
                  <FormLabel>Status</FormLabel>
                  <SelectStatus
                    collection="grades"
                    onValueChange={(val) => field.onChange(val)}
                    {...field}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="grades"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default GradeForm;
